import React, { useState, useEffect } from "react";

import "./stylesBettingActivity.css";

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";
import RebetLoader from "../../../../CommonComponents/RebetLoader/RebetLoader";
import createPrivateAdminPanelInstance from "../../../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../../../api/ApiRoutes";
import { useSearchParams } from "react-router-dom";
import { AppStrings } from "../../../../../utils/constants/AppStrings";

ChartJS.register(ArcElement, Tooltip, Legend);

const options = {
  plugins: {
    legend: {
      display: false,
    },
    datalabels: {
      display: false,
    },
    tooltip: {
      enabled: true,
      backgroundColor: "#252729",
      titleFont: {
        family: "Poppins-regular",
        size: 16,
        weight: "bold",
      },
      bodyFont: {
        family: "Poppins-regular",
        size: 14,
      },
      padding: 15,
      displayColors: true,
      callbacks: {
        label: function (tooltipItem) {
          const label = tooltipItem.dataset.label || "";
          const value = tooltipItem.raw;
          return `${label}: ${Intl.NumberFormat("en-US").format(value)}`;
        },
      },
    },
  },
};
// red and green  
const colors = ["#943126", "#2a7341"];

function BettingActivity() {
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken,
    false
  );

  const [searchParams] = useSearchParams();
  const eventId = searchParams.get("event-id");

  const [isApiRunning, setIsApiRunning] = useState(false);

  const [chartData, setChartData] = useState({
    labels: ["Pre-Match", "Live"],
    datasets: [
      {
        label: false,
        data: [0, 0],
        backgroundColor: colors,
        borderColor: colors,
        borderWidth: 1,
      },
    ],
  });

  const labels = chartData?.labels;

  const getBettingActivity = async () => {
    setIsApiRunning(true); 
    try {
      const requests = [
        PrivateAdminPanelInstance.post(
          API_ROUTES.GET_EVENT_DETAILS_KPI_BET_ACTIVITY,
          { event_id: eventId, provider: "sportradar" }
        ),
      ];

      const responses = await Promise.allSettled(requests);
      const [sportradarResponse] = responses;

      if (sportradarResponse.status === "fulfilled") {
        const data = sportradarResponse?.value?.data?.data?.data || [];

        console.log("data betting activity", data);
        const preMatch =
          data.find((item) => item.label === "Pre-match")?.value || 0;
        const live = data.find((item) => item.label === "Live")?.value || 0;
        

        setChartData({
          labels: ["Pre-Match", "Live"],
          datasets: [
            {
              label: false,
              data: [preMatch, live],
              backgroundColor: colors,
              borderColor: colors,
              borderWidth: 1,
            },
          ],
        });
      }
    } catch (error) {
      console.log("Error getting bet types:", error);
    } finally {
      setIsApiRunning(false);
    }
  };

  useEffect(() => {
    getBettingActivity();
  }, []);

  return (
    <div className="betting-activity-container">
      <div className="betting-activity-header">
        <h2>{AppStrings.BET_ACTIVITY}</h2>
      </div>
      <div className="betting-activity-content">
        {isApiRunning ? (
          <RebetLoader width={100} height={100} />
        ) : (
          <>
            <div className="betting-activity-chart">
              <Pie data={chartData} options={options} />
            </div>
            <div className="betting-activity-legend">
              {labels.map((label, index) => (
                <div className="betting-activity-legend-item" key={index}>
                  <div
                    className="betting-activity-legend-item-color"
                    style={{ backgroundColor: colors[index] }}
                  />
                  <span className="betting-activity-legend-item-label">
                    {label}
                  </span>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default BettingActivity;
